import React from 'react';
import styled from 'styled-components';
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { remove, findIndex, forEach, find } from 'lodash';
import {isMobileOnly} from 'react-device-detect';
import MyEsReqFormBrList from './MyEsReqFormBrList'
import * as F from '../../lib/util/CommonFunctions';

const ReqFormListBlock = styled.div`
    ${isMobileOnly?`

    `:`
    margin-top: 20px;
    `};
`;

const ReqFormListTotalBlock = styled.div`
    background-color: #f4f4f4;
    //border-top: 2px solid #111111;
    height : 150px;
    border-bottom-left-radius: 40px;
`;

const ReqFormListTotalItemBottomBlock = styled.div`
    position: relative;
    float: left;
    min-width: 150px;
    //min-height: 130px;
    padding: 40px 10px;
    border-radius: 65px;
    //background-color: #e0e0e0;
    text-align: center;
    width: 200px;
    

    &.minus-icon::after {
    top: 49%;
    right: -13px;
    width: 26px;
    height: 26px;
    -webkit-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    z-index: 1;
    }

    &.equal-icon::after {
        top: 49%;
        right: -13px;
        width: 26px;
        height: 26px;
        -webkit-transform: translateY(-50%);
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
        z-index: 1;
      }
`;

const ReqFormListTotalItemBottomTitleBlock = styled.div`
    line-height: 1.81;
    display: block;
    margin-bottom: 10px;
    color: #111111;
    font-size: 14px;
    font-weight: normal;
    text-align:center;
    height: 20px;
`;

const ReqFormListTotalItemBottomPriceBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 10px;
    float: left;
    `:`
    height: 20px;
    line-height: 1.55;
    `};
`;

const MobileReqFormListTotalBlock = styled.div`
    background-color: #f4f4f4;
    //border-top: 2px solid #111111;
    height : 163px;
    padding: 22px 20px 30px 20px;
    border-bottom-left-radius: 20px;
`;

const MobileReqFormListTotalItemBottomBlock = styled.div`
    position: relative;
    width: 100%;
    height: 20px;
    margin-bottom: 10px;
`;

const MobileReqFormListTotalItemBottomTitleBlock = styled.div`
    line-height: 1.5;
    display: block;
    color: #333333;
    font-size: 12px;
    font-weight: normal;
    float: left;
    padding-top: 1px;
    
`;

const MobileReqFormListTotalItemBottomPriceBlock = styled.div`
    text-align:right;
    float: right;
    color: #111111;
    font-size: 14px;
`;

const MobileReqFormListTotalLineBlock = styled.div`
      margin: 0 0 14px 0;
      height : 1px;
      background-color: #cccccc;
`;
const MyEsReqFormList = ({handlerBrandChangeQty, handlerDeleteItem, handlerInput, handlerPrice, handleFocus , handleBlur}) => {
    const dispatch = useDispatch();
    const [normalPrice, setNormalPrice] = useState(10000);
    const [salePrice, setSalePrice] = useState(100000);
    const [totalPrice, setTotalPrice] = useState(5650);

    const { accessToken, esItems, reqProdList } = useSelector(
        ({ userReducer, userCartReducer, esItemsReducer }) => ({
            accessToken: userReducer.accessToken,
            reqProdList: userCartReducer.reqProdList,
            esItems: esItemsReducer.esItems,
        })
    );

    useEffect(() => {
        if(reqProdList !== null && reqProdList !== undefined) {
            let tPrice = 0; //할인된 상품 금액
            let sPrice = 0; //상품 할인 금액
            let nPrice = 0; //정상 상품 가격
            let count = 0;
            forEach(reqProdList, (item, index) => {
                if( item !== undefined && item !== null &&  item.list !== undefined && item.list !== null ){
                    forEach(item.list, (curobj, index) => {
                        let nPrice2 = curobj.prdct_price*1*curobj.qty*1;
                        let tPrice2 = curobj.es_opt_pirce*1*curobj.qty*1;
                        if(curobj.sale_price === curobj.prdct_price) {
                            nPrice2 = tPrice2;
                        }
                        nPrice += nPrice2;
                        tPrice += tPrice2;
                    });
                }
            });
            setTotalPrice(tPrice);
            setNormalPrice(nPrice);
            sPrice = nPrice - tPrice;
            setSalePrice(sPrice);
            
        }

    }, [reqProdList])

    if (reqProdList === null || reqProdList === undefined) {
        return <ReqFormListBlock />
    }

    return (
        <ReqFormListBlock>
        {
            reqProdList.map((item, idx) => {
               return <MyEsReqFormBrList key={(item.brnd_id) * 1 + idx} item={item} handlerBrandChangeQty={handlerBrandChangeQty} 
                handlerDeleteItem={handlerDeleteItem} handlerInput={handlerInput} handlerPrice={handlerPrice} handleFocus={handleFocus} handleBlur={handleBlur}/>
            })
        }
        {
            isMobileOnly ? 
            <MobileReqFormListTotalBlock className="clearfix">
                <div style={{ width:'100%'}}>
                    <MobileReqFormListTotalItemBottomBlock >
                        <MobileReqFormListTotalItemBottomTitleBlock>총 정상 금액</MobileReqFormListTotalItemBottomTitleBlock>
                        <MobileReqFormListTotalItemBottomPriceBlock>
                            {normalPrice*1 === 0 ? 
                            <span style={{ fontSize:"14px", fontWeight:"600"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:normalPrice, fontSize:"14px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })
                            }
                            
                        </MobileReqFormListTotalItemBottomPriceBlock>
                    </MobileReqFormListTotalItemBottomBlock>
                    <MobileReqFormListTotalItemBottomBlock  style={{marginBottom:'20px'}}>
                        <MobileReqFormListTotalItemBottomTitleBlock>총 할인 금액</MobileReqFormListTotalItemBottomTitleBlock>
                        <MobileReqFormListTotalItemBottomPriceBlock>
                        {salePrice*1 === 0 ? 
                            <span style={{ fontSize:"14px", fontWeight:"600"}}>0<span style={{ fontSize:"14px", fontWeight:"normal"}}>원</span></span>
                            :
                            <span style={{ float:'left'}}> - <div style={{ float:'right'}}>{F.showAmount({amount:salePrice, fontSize:"14px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px" })}</div></span>
                            }
                        </MobileReqFormListTotalItemBottomPriceBlock>
                    </MobileReqFormListTotalItemBottomBlock>
                    <MobileReqFormListTotalLineBlock />
                    <MobileReqFormListTotalItemBottomBlock style={{height:'29px'}}>
                        <MobileReqFormListTotalItemBottomTitleBlock style={{paddingTop:'10px'}}>총 상품 금액</MobileReqFormListTotalItemBottomTitleBlock>
                        <MobileReqFormListTotalItemBottomPriceBlock>
                            {totalPrice*1 === 0 ? 
                            <span style={{ fontSize:"24px", fontWeight:"600", color:'#fc1c67'}}>0<span style={{ fontSize:"14px", fontWeight:"normal", color:'#111111'}}>원</span></span>
                            :
                            F.showAmount({amount:totalPrice, fontSize:"24px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"14px", color:'#fc1c67', unitColor:'#111111' })
                            }
                        </MobileReqFormListTotalItemBottomPriceBlock>
                    </MobileReqFormListTotalItemBottomBlock>
                </div>
            </MobileReqFormListTotalBlock>
            :
            <ReqFormListTotalBlock className="clearfix">
                <div style={{ display: 'flex', justifyContent: 'center', width:'100%', float:'left'}}>
                    <ReqFormListTotalItemBottomBlock className="minus-icon">
                        <ReqFormListTotalItemBottomTitleBlock>총 정상 금액</ReqFormListTotalItemBottomTitleBlock>
                        <ReqFormListTotalItemBottomPriceBlock>
                            {normalPrice*1 === 0 ? 
                            <span style={{ fontSize:"20px", fontWeight:"600"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:normalPrice, fontSize:"20px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                            }
                            
                        </ReqFormListTotalItemBottomPriceBlock>
                    </ReqFormListTotalItemBottomBlock>
                    <ReqFormListTotalItemBottomBlock className="equal-icon">
                        <ReqFormListTotalItemBottomTitleBlock>총 할인 금액</ReqFormListTotalItemBottomTitleBlock>
                        <ReqFormListTotalItemBottomPriceBlock>
                        {salePrice*1 === 0 ? 
                            <span style={{ fontSize:"20px", fontWeight:"600"}}>0<span style={{ fontSize:"18px", fontWeight:"normal"}}>원</span></span>
                            :
                            F.showAmount({amount:salePrice, fontSize:"20px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px" })
                            }
                        </ReqFormListTotalItemBottomPriceBlock>
                    </ReqFormListTotalItemBottomBlock>
                    <ReqFormListTotalItemBottomBlock>
                        <ReqFormListTotalItemBottomTitleBlock>총 상품 금액</ReqFormListTotalItemBottomTitleBlock>
                        <ReqFormListTotalItemBottomPriceBlock>
                            {totalPrice*1 === 0 ? 
                            <span style={{ fontSize:"20px", fontWeight:"600", color:'#fc1c67'}}>0<span style={{ fontSize:"18px", fontWeight:"normal", color:'#111111'}}>원</span></span>
                            :
                            F.showAmount({amount:totalPrice, fontSize:"20px", weight:"600", unit:"원", falseVal:"0원", unitWeight:'normal',unitFontSize:"18px", color:'#fc1c67', unitColor:'#111111' })
                            }
                        </ReqFormListTotalItemBottomPriceBlock>
                    </ReqFormListTotalItemBottomBlock>
                </div>
            </ReqFormListTotalBlock>
        }
        
        </ReqFormListBlock>
    );
};

export default MyEsReqFormList;